import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import axios from 'axios';
import './index.css';
import { BASE_URL } from './constants/api';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

axios.defaults.baseURL = BASE_URL;
